export const enum CompletionStatus {
    Completed,
    Cancelled,
}

export interface BlobSliceManagerValues {
    onCompletePromise: Promise<CompletionStatus>;
    cancel: () => void;
}

export interface BlobSliceManagerProperties {
    sliceSize?: number;
    numberOfSlicesToParallelize?: number;
}

export type SliceAction = (
    blobSlice: Blob,
    sliceNumber: number,
    totalSlices: number
) => Promise<void>;

/**
 * Contains informations of the bytes in a blob slice.
 * It has a start (inclusive) and and end (exclusive).
 */
export interface SliceByteRange {
    /**
     * The start of the byte range (inclusive).
     */
    start: number;

    /**
     * The end of the byte range (exclusive)
     */
    end: number;
}
